import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take, tap } from 'rxjs/operators';
import { UserAuthActions } from '../../store/user/auth/user-auth.actions';
import { selectUserAuthState } from '../../store/user/auth/user-auth.selectors';
import { firstAllowedAppRoute } from '../constants/app-config.constants';
import { BYPASS_PRIVILEGE_CHECKS } from '../constants/feature-flags.constants';

export const privilegeGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);
  const required = (route.data['privileges'] as string[] | undefined) ?? [];

  if (required.length === 0 || BYPASS_PRIVILEGE_CHECKS) {
    return true;
  }

  return store.select(selectUserAuthState).pipe(
    tap((state) => {
      if (!state.isLoading && !state.userDetails && !state.error) {
        store.dispatch(UserAuthActions.loadUserDetails());
      }
    }),
    filter((state) => !state.isLoading && (!!state.userDetails || !!state.error)),
    take(1),
    map((state) => {
      const privileges = (state.userDetails?.privileges ?? []) as string[];
      const allowed = required.some((privilege) => privileges.includes(privilege));
      return allowed ? true : router.parseUrl(firstAllowedAppRoute(privileges));
    })
  );
};
